import { render, staticRenderFns } from "./DomainMonitorAdd.vue?vue&type=template&id=30494880&scoped=true&"
import script from "./DomainMonitorAdd.vue?vue&type=script&lang=js&"
export * from "./DomainMonitorAdd.vue?vue&type=script&lang=js&"
import style0 from "./DomainMonitorAdd.vue?vue&type=style&index=0&id=30494880&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30494880",
  null
  
)

export default component.exports